import {ChatMember} from './chat-members';

/**
 * THE GROUP'S MEMBERS | ADD PANES (ITP-E-203-05), after carbon's `membersView` (OCA-E-160, origin/main `ChatPanel.tsx`
 * 3382-3502), with ITP's own rule on leaving (ITP-P-33 Q11): leaving keeps a member's history and being removed does
 * not, so the reader's own row offers Leave, never remove.
 */

/** The one control on a member's row: Leave on the reader's own, remove on anybody else's while they may manage. */
export type MemberRowAction = 'leave' | 'remove' | 'none';

export function memberRowAction(row: { email: string }, me: string | null | undefined, canManage: boolean): MemberRowAction {
  const self = (me || '').trim().toLowerCase();
  if (self && (row?.email || '').trim().toLowerCase() === self) {
    return 'leave';
  }
  return canManage ? 'remove' : 'none';
}

/** Who the Add pane offers: the company's people not in the group, A to Z; never XatBot, never the reader. */
export function addCandidates<T extends ChatMember>(people: readonly T[], members: readonly { email: string }[],
                                                    me?: string | null): T[] {
  const taken = new Set((members || []).map(member => (member.email || '').toLowerCase()));
  const self = (me || '').toLowerCase();
  return people
    .filter(person => !person.isXatBot && !!person.email)
    .filter(person => !taken.has(person.email.toLowerCase()) && person.email.toLowerCase() !== self)
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, {sensitivity: 'base'}));
}
